import { getNormalizedNetwork } from 'app/dealer/account/utils';

import * as ActionTypes from './constants';

/**
 * @typedef {Object} Network
 * @property {string} id
 * @property {boolean} active
 * @property {boolean} deleted
 * @property {string} name
 * @property {string} street
 * @property {string} city
 * @property {string|number} zip
 * @property {string} country
 * @property {string} responsiblePersonFirstName
 * @property {string} responsiblePersonLastName
 * @property {string} responsiblePersonEmail
 * @property {string} responsiblePersonPhone
 * @property {string} email
 * @property {string} phone
 * @property {string} guaranteeType
 * @property {string} createdAt
 * @property {string} lastUpdatedAt
 * @property {string} rolloutDate
 * @property {string} leadPlan
 */

/**
 * @typedef {Object} NetworkState
 * @property {any} error
 * @property {Network} network
 * @property {boolean} networkCompleted
 * @property {boolean} networkPending
 * @property {boolean} phoneValid
 * @property {boolean} phoneValidPending
 * @property {boolean} responsiblePersonPhoneValid
 * @property {boolean} responsiblePersonPhoneValidPending
 * @property {boolean} zipValid
 * @property {boolean} zipValidPending
 * @property {boolean} showAddPaymentMethodNotification
 */

/**
 * @returns {Network}
 */
export const defaultState = () => {
  return {
    error: null,
    network: getNormalizedNetwork({}),
    networkCompleted: false,
    networkPending: false,
    phoneValid: true,
    phoneValidPending: false,
    responsiblePersonPhoneValid: true,
    responsiblePersonPhoneValidPending: false,
    zipValid: true,
    zipValidPending: false,
    showAddPaymentMethodNotification: true,
  };
};

// TODO: rewrite this reducer - it's not following the redux pattern
export function network(state = defaultState(), action) {
  const { type, payload, error } = action;

  if (type === ActionTypes.FETCH_NETWORK_REQUEST) {
    state = {
      ...state,
      networkPending: true,
    };
  }

  if (type === ActionTypes.FETCH_NETWORK_SUCCESS) {
    state = {
      ...state,
      network: getNormalizedNetwork(payload),
      error: null,
      networkPending: false,
      networkCompleted: false,
    };
  }

  if (type === ActionTypes.FETCH_NETWORK_FAILURE) {
    state = {
      ...state,
      network: getNormalizedNetwork({}),
      networkPending: false,
      networkCompleted: false,
      error,
    };
  }

  if (type === ActionTypes.UPDATE_NETWORK) {
    const newNetwork = {
      ...state.network,
      ...payload,
    };

    state = {
      ...state,
      network: newNetwork,
    };
  }

  if (type === ActionTypes.RESET_NETWORK) {
    state = defaultState();
  }

  if (type === ActionTypes.RESET_NETWORK_STATES) {
    const defaultStateCache = defaultState();

    delete defaultStateCache.network;

    state = {
      ...state,
      ...defaultStateCache,
    };
  }

  if (type === ActionTypes.SUBMIT_NETWORK_REQUEST) {
    state = {
      ...state,
      networkPending: true,
      networkCompleted: false,
    };
  }

  if (type === ActionTypes.SUBMIT_NETWORK_SUCCESS) {
    const network = getNormalizedNetwork(payload);

    state = {
      ...state,
      network,
      networkCompleted: true,
      networkPending: false,
      error: null,
    };
  }

  if (type === ActionTypes.SUBMIT_NETWORK_FAILURE) {
    state = {
      ...state,
      networkCompleted: false,
      networkPending: false,
      error,
    };
  }

  if (type === ActionTypes.CHECK_NETWORK_PHONE_REQUEST) {
    state = {
      ...state,
      phoneValidPending: true,
      phoneValid: true,
    };
  }

  if (type === ActionTypes.CHECK_NETWORK_PHONE_SUCCESS) {
    state = {
      ...state,
      phoneValidPending: false,
      phoneValid: true,
    };
  }

  if (type === ActionTypes.CHECK_NETWORK_PHONE_FAILURE) {
    state = {
      ...state,
      phoneValidPending: false,
      phoneValid: false,
    };
  }

  if (type === ActionTypes.CHECK_NETWORK_RESPONSIBLE_PERSON_PHONE_REQUEST) {
    state = {
      ...state,
      responsiblePersonPhoneValidPending: true,
      responsiblePersonPhoneValid: true,
    };
  }

  if (type === ActionTypes.CHECK_NETWORK_RESPONSIBLE_PERSON_PHONE_SUCCESS) {
    state = {
      ...state,
      responsiblePersonPhoneValidPending: false,
      responsiblePersonPhoneValid: true,
    };
  }

  if (type === ActionTypes.CHECK_NETWORK_RESPONSIBLE_PERSON_PHONE_FAILURE) {
    state = {
      ...state,
      responsiblePersonPhoneValidPending: false,
      responsiblePersonPhoneValid: false,
    };
  }

  if (type === ActionTypes.CHECK_NETWORK_ZIP_REQUEST) {
    state = {
      ...state,
      zipValidPending: true,
    };
  }

  if (type === ActionTypes.CHECK_NETWORK_ZIP_SUCCESS) {
    state = {
      ...state,
      zipValidPending: false,
      zipValid: true,
    };
  }

  if (type === ActionTypes.CHECK_NETWORK_ZIP_FAILURE) {
    state = {
      ...state,
      zipValidPending: false,
      zipValid: false,
    };
  }

  if (type === ActionTypes.CLOSE_ADD_PAYMENT_METHOD_NOTIFICATION) {
    state = {
      ...state,
      showAddPaymentMethodNotification: false,
    };
  }

  return state;
}
